"use strict";
angular.module('DetailRouterModule', [])
    .config(['$stateProvider', function($stateProvider) {
        $stateProvider
            .state('planningcenterwenzhangdetail', {
                url: '/planwenzhangdetail?SID',
                views: {
                    '': {
                        templateUrl: './planningCenter/realTimeClues/suddenClues/zjPublicOpinion/detail/wenzhangDetail_tpl.html',
                        controller: 'planningcenterWenZhangDetailCtrl'
                    }
                }
            })
            .state('planningcenterweibodetail', {
                url: '/planweibodetail?SID',
                views: {
                    '': {
                        templateUrl: './planningCenter/realTimeClues/suddenClues/zjPublicOpinion/detail/weiboDetail_tpl.html',
                        controller: 'planningcenterWeiBoDetailCtrl'
                    }
                }
            });
    }]);
